// Learning from Failure Template - Common App Prompt #2
export const learningFromFailureTemplate = {
  id: 'learningFromFailure',
  title: 'Learning from Failure',
  description: 'For recounting challenges, setbacks, or failures that taught fundamental lessons leading to later success',
  sections: [
    {
      id: 'the_failure_moment',
      label: 'The Failure Moment',
      type: 'opening',
      prompt: 'Take me to the exact moment you realized you had failed. What did failure look and feel like?',
      coachVoice: "Don't soften this or make it sound noble. Show me the raw moment of recognizing you'd actually failed at something that mattered to you.",
      sample: "The email subject line was brutal in its simplicity: 'Thank you for your audition.' I didn't even need to open it to know. After two years of voice lessons and months of preparation, I hadn't made the state choir. My voice teacher's 'you're definitely ready' echoed mockingly in my head.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'what_the_failure_exposed',
      label: 'What the Failure Exposed',
      type: 'stakes',
      prompt: 'What did this failure reveal about your assumptions, preparation, or understanding of yourself?',
      coachVoice: "Failure is a brutal teacher because it exposes what we didn't know we didn't know. What misconception about yourself or the world got shattered?",
      sample: "I realized I'd been coasting on natural talent without understanding that at higher levels, everyone has talent. What separated successful performers wasn't just ability - it was the willingness to be vulnerable, to risk sounding bad while pushing their limits. I'd been playing it safe, never truly challenging myself.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'your_learning_process',
      label: 'Your Learning Process',
      type: 'approach',
      prompt: 'How did you systematically figure out what went wrong and what needed to change?',
      coachVoice: "Show me your detective work. How did YOUR mind approach understanding and fixing what broke down?",
      sample: "I recorded myself singing the same audition pieces, but this time I closed my eyes and sang like no one was listening. The difference was startling - I sounded alive. I developed a practice routine of 'ugly singing' - deliberately pushing past my comfort zone until my voice cracked, then finding my way back to control from that edge.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'how_failure_changed_your_success',
      label: 'How Failure Changed Your Success',
      type: 'growth',
      prompt: 'Give me specific evidence of how this failure fundamentally changed your approach to challenges.',
      coachVoice: "I need proof this wasn't just a temporary setback. How does this lesson show up in completely different areas of your life now?",
      sample: "When I started learning guitar this year, my friends were amazed I wasn't embarrassed by my mistakes. I deliberately practiced in public spaces, letting my failures be visible. That willingness to fail openly that I learned from choir has become my secret weapon - I improve faster because I'm not afraid to sound terrible while learning.",
      minWords: 80
    }
  ]
};